import { Component, inject } from '@angular/core';
import { NzModalRef, NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { BehaviorSubject } from 'rxjs';
import { EventViewModel } from '../../models-views/event.view.model';
import { AdvancePayment, Payment } from '../../models/event.model';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

interface IModalData {
  id: number;
  name: string;
}

@Component({
  selector: 'app-advanced-payment-details',
  standalone: false,
  templateUrl: './advanced-payment-details.component.html',
  styleUrl: './advanced-payment-details.component.scss'
})

export class AdvancedPaymentDetailsComponent {
  loading:boolean = true
  modalData?: IModalData;
  payment: any;
  advancePaymentDetailsModel = new BehaviorSubject<AdvancePayment>(new AdvancePayment())

  constructor(private vm:EventViewModel,private modalRef: NzModalRef,
    private http: HttpClient
  ) {
    this.modalData = inject(NZ_MODAL_DATA); // Moved here
    this.vm.advancedPaymentDetailsComponent = this;
    this.vm.subscribeToAdvancePaymentDetails(this.advancePaymentDetailsModel)
  }
  
  ngOnInit():void {
    console.log(this.modalData)

   this.modalData  && this.vm.getAdvancePaymentById(this.modalData.id)
  }

  getStatusColor(status: string): string {
    switch (status?.toLowerCase()) {
      case 'completed': return 'green';
      case 'pending': return 'gold';
      case 'failed': return 'red';
      default: return 'default';
    }
  }

  paymentDetailRecieved(){
    this.payment = this.advancePaymentDetailsModel.value
    this.loading = false
    console.log(this.payment)
  }

  getFileName(file_url:string): string {
    return file_url.split('/').pop()?.split('?')[0] || '';
  }

  close(): void {
    this.modalRef.close(false);
  }

  
// handleDownload(url: string, fileName: string) {
//   if (!url) return;
  
//   if (!url.startsWith('http')) {
//     url = `${environment.api_url}${url}`;
//   }

//   console.log('Downloading file:', url);

//   this.http.get(url, {
//     responseType: 'blob'
//   }).subscribe({
//     next: (blob) => {
//       const blobUrl = URL.createObjectURL(blob);
//       const link = document.createElement('a');
//       link.href = blobUrl;
//       link.download = fileName || 'download';
//       link.click();
//       URL.revokeObjectURL(blobUrl);
//     },
//     error: (err) => {
//       console.error('Download failed', err);
//     }
//   });
// }


    handleDownload(url: string, fileName: string) {
  console.log('Original URL:', url, 'fileName:', fileName);

  if (url && !url.startsWith('http')) {
    url = `${environment.api_url}${url}`;
  }


  this.http.get(url, { responseType: 'blob' }).subscribe({
    next: (blob) => {
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileName || 'download';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl);
    },
    error: (err) => {
      console.error('Download failed:', err);
    }
  });
}

}
